export const APPLICATION_FETCH_UPDATE = 'APPLICATION_FETCH_UPDATE'
export const RESET_APPLICATION_FETCH_UPDATE = 'RESET_APPLICATION_FETCH_UPDATE'
export const APPLICATION_FETCH_UPDATE_SUCCESS = 'APPLICATION_FETCH_UPDATE_SUCCESS'
export const APPLICATION_FETCH_UPDATE_ERROR = 'APPLICATION_FETCH_UPDATE_ERROR'
export const APPLICATION_INSTALL_UPDATE = 'APPLICATION_INSTALL_UPDATE'
export const APPLICATION_INSTALL_UPDATE_SUCCESS = 'APPLICATION_INSTALL_UPDATE_SUCCESS'
export const APPLICATION_INSTALL_UPDATE_ERROR = 'APPLICATION_INSTALL_UPDATE_ERROR'
export const APPLICATION_CHECK_VERSION = 'APPLICATION_CHECK_VERSION'
export const APPLICATION_CHECK_VERSION_VALIDVERSION = 'APPLICATION_CHECK_VERSION_VALIDVERSION'
export const APPLICATION_CHECK_VERSION_INVALIDVERSION = 'APPLICATION_CHECK_VERSION_INVALIDVERSION'
export const REMOTE_SELLING_CREATE_NEW_LINK = 'REMOTE_SELLING_CREATE_NEW_LINK'
export const REMOTE_SELLING_SUBMIT_RESUME_MODAL = 'REMOTE_SELLING_SUBMIT_RESUME_MODAL'
export const REMOTE_SELLING_USING_EXISTS_LINK = 'REMOTE_SELLING_USING_EXISTS_LINK'
export const REMOTE_SELLING_RESET_DATA = 'REMOTE_SELLING_RESET_DATA'
export const ENTER_REMOTE_SELLING = 'ENTER_REMOTE_SELLING'
export const CONFIRM_REMOTE_SELLING = 'CONFIRM_REMOTE_SELLING'
export const CLEAR_REMOTE_SELLING_RESULT = 'CLEAR_REMOTE_SELLING_RESULT'
export const CLEAR_EKYC_RESULT = 'CLEAR_EKYC_RESULT'
export const ENTER_EKYC_F2F = 'ENTER_EKYC_F2F'

export const ACTIONS = {
  RESET_APPLICATION_FETCH_UPDATE,
  APPLICATION_FETCH_UPDATE,
  APPLICATION_FETCH_UPDATE_SUCCESS,
  APPLICATION_FETCH_UPDATE_ERROR,
  APPLICATION_INSTALL_UPDATE,
  APPLICATION_INSTALL_UPDATE_SUCCESS,
  APPLICATION_INSTALL_UPDATE_ERROR,
  APPLICATION_CHECK_VERSION,
  APPLICATION_CHECK_VERSION_VALIDVERSION,
  APPLICATION_CHECK_VERSION_INVALIDVERSION,
  REMOTE_SELLING_CREATE_NEW_LINK,
  REMOTE_SELLING_USING_EXISTS_LINK,
  REMOTE_SELLING_RESET_DATA,
  REMOTE_SELLING_SUBMIT_RESUME_MODAL,
  ENTER_REMOTE_SELLING,
  CONFIRM_REMOTE_SELLING,
  CLEAR_REMOTE_SELLING_RESULT,
  CLEAR_EKYC_RESULT,
  ENTER_EKYC_F2F,
}

export default ACTIONS
